import React from 'react';
import {isRTL} from "../../helpers/i18n";
import FormInput from "./FormInput";
import {t} from "i18next";
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

const CustomPhone = (props) => {
    const { value, onChange, error, country_code, label, disabled, ...rest } = props;

    return (
        <FormInput label={label ?? t('phone-number')} error={error ?? null} {...rest}>
            <PhoneInput
                className={`custom-phone ${disabled ? 'disabled' : ''} ${isRTL() ? 'rtl' : ''}`}
                label={isRTL() ? t('phone') : t(' ')}
                onChange={(val) => onChange(val)}
                value={value}
                countryCallingCodeEditable={false}
                defaultCountry={country_code ?? 'NO'}
                autoComplete={'phone'}
                id={'phone'}
                international
                disabled={disabled ?? false}
            />
        </FormInput>
    );
};

export default CustomPhone;